import {Stack, Typography, Box} from '@mui/material'
import InboxIcon from '@mui/icons-material/Inbox'

export function BlankList(props) {
    return (
        <Stack 
            alignItems="center" 
            justifyContent="center"
            spacing={2}
            sx={{
                py: 8,
                px: 3,
                bgcolor: 'background.paper',
                borderRadius: 4,
                border: '1px dashed rgba(211, 47, 47, 0.3)',
                maxWidth: '450px',
                margin: '40px auto 0 auto',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
            }}
        >
            <Box 
                sx={{
                    width: 70,
                    height: 70,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: 'rgba(211, 47, 47, 0.1)',
                    color: '#d32f2f',
                    mb: 1
                }}
            >
                <InboxIcon sx={{ fontSize: 40 }} />
            </Box>
            <Typography variant="h6" sx={{ fontWeight: '700', color: 'text.primary', fontSize: '18px' }}>
                لیست خالی است!
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '14px', textAlign: 'center' }}>
                هیچ موردی برای نمایش در این بخش یافت نشد.
            </Typography>
        </Stack>
    )
}
